import FAQPage from 'screens/FAQ/FAQ';

export default FAQPage;
